export default {
  menu_rename: '重命名',
  menu_delete: '删除',
  menu_move_to: '移动到',
  menu_add_to_favorites: '收藏',
  menu_remove_to_favorites: '取消收藏',
  menu_add_to_favorites_successfully: '收藏成功',
  menu_remove_from_favorites_successfully: '已移出收藏夹',
  menu_dataset: '数据表',
  menu_edit: '编辑',
  menu_order: '调整顺序',
  menu_new: '新建',
  subscribe_left_menu_management: '订阅管理',
  event_left_menu_management: '订阅管理',
  menu_download: '下载指引',
  menu_new_menu: '新建菜单',
  menu_subscribe: '订阅',
  menu_new_folder: '新建目录',
  menu_new_subfolder: '新建子目录',
  menu_new_dashboard: '新建报表',
  menu_download_guidelines: '下载指引',
  menu_shift_up: '向上移',
  menu_shift_down: '向下移',

  menu_confirm: '确认',
  menu_cancel: '取消',
  menu_info_move: '是否确认移动？',
  menu_info_fav_del: '是否取消收藏该报表?',
  menu_info_del_1: '确认删除',
  menu_info_del_2: '是否确认删除',
  menu_info_del_3: '删除后不可恢复，请谨慎操作！',
  menu_info_name_err: '仅支持输入汉字、字母、数字以及特殊字符(- _ < > " “ & : ’：\')',
  menu_info_name_exist: '已存在，请修改',

  dashboard: '经分',
  dashboard_title: '报表',
  folder: '目录',
  subfolder: '子目录',
  menu: '菜单',
  name: '名称',
  chinese: '中文',
  menu_level: '权限级别',
  menu_link: '路径',
  menu_path_type_webhook_url: 'Tableau Default',
  menu_path_type_url: 'Other Tableau',
  menu_path_type_Path: 'Frame Reports',
  menu_path_type_preset: 'Preset',
  menu_path_type_datalab: 'Datalab',
  menu_path_type_pdf: 'PDF',
  menu_path_type_dashApp: 'Dash App',
  menu_path_type_custom: 'Customized',
  menu_path_type_public_url: 'Web Url',
  menu_path_type_cos_url: 'Cos Url',
  menu_path_type_looker: 'Looker',
  menu_path_type_out_url: 'Out Url',
  menu_path_type_out_path: 'Out Path',
  menu_path_type_auth_path: 'Auth Path',

  menu_path_placeholder: '请选择页面路径',
  menu_path_path_placeholder: '请选择页面路径',
  menu_path_tableau_placeholder: '请输入Tableau报表',
  menu_path_datalab_placeholder: '请输入Datalab报表',
  menu_path_preset_placeholder: '请输入Preset报表',
  menu_path_pdf_placeholder: '粘贴PDF链接或者上传PDF文档',
  menu_path_dashApp_placeholder: '请输入Dash App报表',
  menu_path_public_url_placeholder: '请输入网页地址',
  menu_path_cos_url_placeholder: '请输入Cos Url报表',
  menu_path_looker_placeholder: '请输入Looker报表',
  menu_path_out_url_placeholder: '请输入Out网页地址',
  menu_path_out_path_placeholder: '请输入Out页面路径',
  menu_path_auth_path_placeholder: '请输入Auth路径',

  menu_name_null: '请输入名称',
  menu_name_max_length_error: '长度不超过50字符',
  menu_select_null: '请选择菜单',
  menu_folder_select_null: '请选择目录',
  menu_subfolder_select_null: '请选择子目录',
  menu_user_level_select_null: '请选择权限级别',
  menu_path_select_null: '请选择权报表',
  menu_path_webhook_url_select_null: '请选择Workbook Url',
  menu_path_path_select_null: '请选择Path路径',
  menu_path_datalab_null: '请输入Datalab报表id',
  menu_path_datalab_err: '请输入正确的Datalab报表id',
  menu_path_preset_null: '请输入Preset报表id',
  menu_path_preset_err: '请输入正确的Preset报表id',
  menu_path_url_null: '请输入Url',
  menu_path_url_err: '请输入正确的Url',
  menu_auth_path_null: '请输入Auth路径',
  menu_auth_path_err: '请输入正确的Auth路径',
  menu_pdf_url_null: '请输入PDF Url',
  menu_pdf_url_err: '请输入正确的PDF Url',
  menu_pdf_format_err: '文件格式错误，请上传PDF文件',
  menu_pdf_uploaded_err: '上传失败，请重新上传',
  menu_dashApp_url_null: '请输入Dash App Url',
  menu_dashApp_url_err: '请输入正确的Dash App Url',
  menu_cos_url_null: '请输入Cos Url',
  menu_cos_url_err: '请输入正确的Cos Url',
  menu_looker_url_null: '请输入Looker Url',
  menu_looker_url_err: '请输入正确的Looker Url',
  menu_looker_models_null: '请输入model(s)',

  menu_folder_name_null: '不可为空，且不超过50字符',
  menu_subfolder_name_null: '不可为空，且不超过50字符',
  menu_menu_name_null: '不可为空，且不超过50字符 ',
  menu_dashboard_name_null: '不可为空，且不超过50字符 ',

  menu_must_contain_less: ' 长度不超过50字符',


  menu_enter_menu_name: '请输入菜单英文名',
  menu_enter_menu_ch_name: '请输入菜单中文名',
  menu_enter_folder_name: '请输入目录英文名',
  menu_enter_subfolder_name: '请输入子目录英文名',
  menu_enter_folder_ch_name: '请输入目录中文名',
  menu_enter_subfolder_ch_name: '请输入子目录中文名',
  menu_Select: '请选择',
  menu_enter_dashboard_name: '请输入报表英文名',
  menu_enter_dashboard_ch_name: '请输入报表中文名',
  menu_select_no_data: '暂无数据',

  menu_menu_re_enter: '已存在，请重新输入',
  menu_folder_re_enter: '已存在，请重新输入',
  menu_subfolder_re_enter: '已存在，请重新输入',
  menu_dashboard_re_enter: '已存在，请重新输入',
  // 30011  dashboard name already exists
  menu_no_any_dashboard_exist: '当前业务还没有配置任何报表',

  preset_ext_info_workspace_id_err: '请输入正确的 preset workspace id',
  preset_ext_info_workspace_region_err: '请输入正确的 preset workspace region',
  preset_ext_info_team_id_err: '请输入正确的 preset team id',
  preset_ext_info_workspace_id_placeholder: '请输入 preset workspace id',
  preset_ext_info_workspace_region_placeholder: '请输入 preset workspace region',
  preset_ext_info_team_id_placeholder: '请输入 preset team id',

  looker_ext_info_models_placeholder: '请输入Looker model(s)',
  looker_ext_info_models_err: '请输入正确的 model(s)',

  menu_extra_info: '额外信息',
  menu_extra_info_placeholder: '请输入额外信息, 例如: type=game&code=123',

  folder_info_name_err: '仅支持输入汉字、字母、数字以及特殊字符(- _ ( ) < > " “ & : ’：\')',

  menu_access_denied: '拒绝访问',
  menu_access_denied_button: '我知道',
  menu_access_denied_tips: '抱歉，您没有当前页面的权限，已为您自动跳转至可访问的报表。',
};
